import { useEffect, useState } from "react";
import { RESTRO_URL } from "./constants";
const useRestaurant = (resId) => {
    const [resInfo, setResInfo] = useState(null);
    const [menuInfo, setMenuInfo] = useState(null);
    useEffect(() => {
        fetchData();
        fetchMenuData();
    }, []);
    const fetchData = async () => {
        try {
            const data = await fetch(RESTRO_URL + resId);

            if (!data.ok) {
                console.error("API request failed with status:", data.status);
                return;
            }

            const json = await data.json();
            if (!json) {
                console.error("Empty response from API");
                return;
            }
            setResInfo(json?.restaurant);
        } catch (err) {
            console.error("Error fetching restaurant data:", err);
        }
    };
    const fetchMenuData = async () => {
        try {
            const data = await fetch(RESTRO_URL + resId + "/menu");

            if (!data.ok) {
                console.error("API request failed with status:", data.status);
                return;
            }

            const json = await data.json();
            if (!json) {
                console.error("Empty response from API");
                return;
            }
            setMenuInfo(json?.restaurant);
        } catch (err) {
            console.error("Error fetching restaurant data:", err);
        }
    };
    return { resInfo, menuInfo };
};

export default useRestaurant;
